import { render, staticRenderFns } from "./EditorHeader.vue?vue&type=template&id=f7108074&scoped=true"
import script from "./EditorHeader.vue?vue&type=script&lang=js"
export * from "./EditorHeader.vue?vue&type=script&lang=js"
import style0 from "./EditorHeader.vue?vue&type=style&index=0&id=f7108074&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7108074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7108074')) {
      api.createRecord('f7108074', component.options)
    } else {
      api.reload('f7108074', component.options)
    }
    module.hot.accept("./EditorHeader.vue?vue&type=template&id=f7108074&scoped=true", function () {
      api.rerender('f7108074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CalculateEditor/EditorHeader.vue"
export default component.exports